import Default from './default';

import ConfiguratorApp from '../components/configuratorApp';

class Configurator extends Default {
  namespace = 'configurator';

  heros = [];

  beforeLeave = (data) => {
    super.beforeLeave(data);
  };

  afterLeave = (data) => {
    super.afterLeave(data);
  }

  beforeEnter = data => {
    const scope = data.next.container;
    super.beforeEnter(data);
    this.initConfiguratorApp(scope);
  };
  
  afterEnter = (data) => {
    super.afterEnter(data);
  }

  initConfiguratorApp = (scope) => {
    const $configuratorApp = $(scope).find('[data-configurator-app="el"]');

    if($configuratorApp.length) {
      new ConfiguratorApp($configuratorApp);
    } 
  };
}

export default new Configurator();